// External Libraries
import React from "react";
import Modal from "react-responsive-modal";
import { Loader } from "react-feather";

// Services
import ConfigurationService from "../../../services/ConfigurationService";
import PlaidService from "../../../services/PlaidService";
import UtilityService from "../../../services/UtilityService";

// Common Components
import WComponent from "../../common/WComponent";
import SearchableDropdown from "../../common/searchable_dropdown/SearchableDropdown";
import Button from "../../common/button/Button";

// Styles
// import "../common/modal/modal.css";
import "./plaid-connection-modal.css";

const { alert } = UtilityService;

class PlaidConnectionModal extends WComponent {
	constructor() {
		super();
		this.state = {
			clientId: null,
			status: null,
			connectionLink: "",
			accounts: [],
			plaidLinkPublicId: "",

			selectedContact: { name: "" },

			loading: false,
			show: false
		};
	}

	componentDidMount() {
		this.resetComponent();
	}

	componentDidUpdate(prevProps) {
		let { clientId, show } = this.props;

		if (prevProps.clientId !== clientId || prevProps.show !== show) {
			this.resetComponent();
		}
	}

	async resetComponent() {
		let { clientId, show } = this.props;

		if (!show) {
			return;
		}

		await this.update({
			show,
			loading: true,
			clientId,
			content: "",

			selectedContact: { name: "" }
		});

		await this.fetchPlaidIntegration();

		await this.update({
			loading: false
		});
	}

	fetchPlaidIntegration = async () => {
		let { clientId } = this.props;

		let plaidLink = await PlaidService.fetchLinks({ clientId });

		if (!plaidLink) {
			await this.update({
				status: null
			});
			return;
		}

		let connectionLink = `${ConfigurationService.resolveApi().clientPortal}connect/${plaidLink.public_id}`;

		if (plaidLink.status === "active") {
			await this.update({
				status: plaidLink.status,
				connectionLink
			});

			return;
		}

		// Default case is that the plaidLink is completed
		let plaidPayload = JSON.parse(plaidLink.payload);
		let accounts = await PlaidService.fetchAccounts({ clientId });

		await this.update({
			status: plaidLink.status,
			connectionLink,
			plaidLinkPublicId: plaidLink.public_id,
			accounts
		});
	};

	show() {
		this.update({
			show: true
		});
	}

	onClose = async confirmed => {
		await this.update({
			show: false
		});

		if (this.props.onClose) {
			this.props.onClose();
		}
	};

	onGenerateConnectionLinkClicked = async () => {
		let { clientId } = this.props;

		await this.update({
			loading: true
		});

		let plaidLink = await PlaidService.createPlaidShortLink({ clientId });

		if (!plaidLink) {
			//error
			return;
		}

		this.fetchPlaidIntegration();

		await this.update({
			loading: false
		});
	};

	doesPlaidLinkExist() {
		let { status } = this.state;
		return status !== null;
	}

	renderAccounts() {
		let { accounts } = this.state;

		return (
			<div className="pcm__accounts">
				Accounts:
				{accounts.map(account => {
					return <div className="pcm__accounts__item">{account.name}</div>;
				})}
			</div>
		);
	}

	renderNone() {
		let { status } = this.state;

		if (status) {
			return null;
		}

		return <div className="pcm__status">Generate a new connection link to share with the client</div>;
	}

	renderActive() {
		let { status, connectionLink } = this.state;

		if (status !== "active" && status !== "processing") {
			return null;
		}

		return (
			<>
				<div className="pcm__status">A connection link has been generated for this client, but they have not connected any accounts yet.</div>
				<div className="pcm__link">
					Connection Link: <a href={connectionLink}>{connectionLink}</a>
				</div>
			</>
		);
	}

	renderCompleted() {
		let { status, connectionLink } = this.state;

		if (status !== "completed") {
			return null;
		}

		return (
			<>
				<div className="pcm__status">This client has connected their bank accounts to Workflow.</div>
				<div className="pcm__link">
					Connection Link: <a href={connectionLink}>{connectionLink}</a>
				</div>
				{this.renderAccounts()}
			</>
		);
	}

	onContactSelect = async contact => {
		await this.update({
			selectedContact: {
				id: contact.id,
				name: contact.name,
				email: contact.email
			}
		});
	};

	onSendEmail = async () => {
		let { plaidLinkPublicId, selectedContact } = this.state;

		let success = await PlaidService.sendConnectEmail({ plaidLinkPublicId, contactId: selectedContact.id });

		if (!success) {
			alert({ type: "error", text: "Error sending email." });
			return;
		}

		alert({ type: "success", text: `Email has been sent to ${selectedContact.email}` });
	};

	renderEmailSender() {
		let { status, clientId, selectedContact } = this.state;

		if (status !== "active" && status !== "processing") {
			return null;
		}

		return (
			<div>
				<br />
				<br />
				<SearchableDropdown
					containerClass="details__general__input-cont"
					clientId={clientId}
					title="Email Contact"
					type={"contacts"}
					selectedName={selectedContact.name}
					onSelect={this.onContactSelect}
					showAll
				/>
				<Button disabled={!selectedContact.email} text="Send Email" onClick={this.onSendEmail} />
			</div>
		);
	}

	render() {
		let { show, loading } = this.state;

		return (
			<Modal open={show} onClose={() => this.onClose(false)} center>
				<div className="pcm">
					<div className="modal-title">{"Bank Account Details"}</div>

					{loading && (
						<div className="container-loader">
							<Loader />
						</div>
					)}
					{!loading && (
						<div className="pcm__body">
							{this.renderNone()}
							{this.renderActive()}
							{this.renderCompleted()}
							{this.renderEmailSender()}
						</div>
					)}
				</div>
				<div className="modal-footer">
					<Button view="secondary" onClick={() => this.onClose(false)} text="Close" />

					{!this.doesPlaidLinkExist() && <Button onClick={this.onGenerateConnectionLinkClicked} text="Generate Link" />}
				</div>
			</Modal>
		);
	}
}

export default PlaidConnectionModal;
